import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
const Categories = function () {

    let linksArray = [];
    let linkIndex = document.querySelectorAll('.categories-all__linklist--link');
    linkIndex.forEach(link => {
        linksArray.push(link);
    });

    let captionArray = [];
    let captions = document.querySelectorAll('.categories-all__caption--text');
    let captionStick = document.querySelector('.caption-stick');    
    captions.forEach(caption => {
        captionArray.push(caption);
    });

    let imageArray = [];
    let images = document.querySelectorAll('.cat-image');
    let imageStick = document.querySelector('.image-stick');
    images.forEach(image => {
        imageArray.push(image);
    });

    if (linkIndex) {
        let i = 0;
        linkIndex.forEach(link => {
            let linkAtt = link.getAttribute('data-link');
            let caption = captionArray[i];
            link.addEventListener('mouseenter', (event) => {
                captionStick.style.opacity = 0;
                captionArray.forEach(caption => {
                    caption.style.opacity = 0;
                });
                for (let i = 0; i < imageArray.length; i++) {
                    let imageSrc = imageArray[i].getAttribute('src');
                    if ( linkAtt == i ) {
                        imageStick.setAttribute('src', imageSrc);
                        caption.style.opacity = 1;
                    }
                }
            });
            i++;
        });
    }


    /////// ANIMATIONS ///////
    gsap.registerPlugin(ScrollTrigger);

    // Intro Section
    const categoryIntro = document.querySelector('.category-intro');
    if ( categoryIntro ) {
        let introEls = categoryIntro.querySelectorAll('.gsap-el');
        const timelineIntro = gsap.timeline({
            scrollTrigger: {
                trigger: categoryIntro,
                scrub: 0.25,
                start: "-10%",
                end: "80%",
                // markers: true
                // pin: true,
                // pinSpacing: true,
            }
        });    
        timelineIntro.to(
            introEls,
            {
                duration: 5,
                y: -200,
                stagger: 0.2,
                opacity: 0
            }   
        );
    }


    // LinkList - Categories links
    const categoriesAll = document.querySelector('.categories-all');
    if ( categoriesAll ) {
        let catEls = categoriesAll.querySelectorAll('.gsap-el');
        let catEls0 = categoriesAll.querySelectorAll('.gsap-el-0');

        let catBlocksArray = [];
        let catBlocks = categoriesAll.querySelectorAll('.cat-block');
        catBlocks.forEach(catBlock => {
            catBlocksArray.push(catBlock);
        });

        let imageWrap = document.querySelector('.cat-image-desktop');
        function catImageOn () {
            imageWrap.classList.toggle('animate');
        }

        ScrollTrigger.matchMedia({
            // XXL
            "(min-width: 1400px)": function() {
                    const timelineCats = gsap.timeline({
                        scrollTrigger: {
                            onEnter: catImageOn,
                            onLeaveBack: catImageOn,
                            trigger: categoriesAll,
                            start: "0% 60%",
                            end: "200% 0%",
                            pin: true,
                            pinSpacing: true,
                            // markers: true,
                            scrub: 0.5
                        }
                    });
                    timelineCats
                    .to( catEls0, {
                        duration: 0.25,
                        y: 0,
                        opacity: 1,
                        delay: 0.25
                    })
                    .to( catEls, {
                        duration: 0.5,
                        y: -90,
                        opacity: 1,
                        stagger: 0.05,
                    })
                    .to( catEls, {
                        duration: 1.5,
                        y: -90,
                        opacity: 1,
                    })
                    .to( catEls, {
                        duration: 1,
                        y: -200,
                        opacity: 0,
                        stagger: 0.1,
                    })
            },

            // large
            "(min-width: 991px) and (max-width: 1400px)": function() {
                    const timelineCats = gsap.timeline({
                        scrollTrigger: {
                            onEnter: catImageOn,
                            onLeaveBack: catImageOn,
                            trigger: categoriesAll,
                            start: "0% 70%",
                            end: "200% 0%",
                            pin: true,
                            pinSpacing: true,
                            // markers: true,
                            scrub: 0.5
                        }
                    });
                    timelineCats
                    .to( catEls0, {
                        duration: 0.125,
                        y: 0,
                        opacity: 1,
                    })
                    .to( catEls, {
                        duration: 0.5,
                        y: -90,
                        opacity: 1,
                        stagger: 0.05,
                    })
                    .to( catEls, {
                        duration: 1.5,
                        y: -90,
                        opacity: 1,
                    })
                    .to( catEls, {
                        duration: 1,
                        y: -200,
                        opacity: 0,
                        stagger: 0.1,
                    })
            },
    
            // small
            "(max-width: 991px)": function() {
                catBlocks.forEach(catBlock => {
                    const timelineCats = gsap.timeline({
                        scrollTrigger: {
                            trigger: catBlock,
                            start: "0% 50%",
                            end: "90% 30%",
                            pin: true,
                            pinSpacing: false,
                            // markers: true,
                            scrub: 0.25
                        }
                    });
                    timelineCats
                    .from(
                        catBlock,
                        {
                            duration: 5,
                            y: 100,
                            opacity: 0,            
                            top: 0
                        }
                    )
                    .to(
                        catBlock,
                        {
                            duration: 10,
                            y: 0,
                            opacity: 1,
                            top: 0
                        }   
                    )
                    .to(
                        catBlock,
                        {
                            duration: 5,
                            y: -100,
                            opacity: 0,
                            top: 0
                        }   
                    );
                });
            }
        }); 
    }
    

    // Content Driven
    const contentDriven = document.querySelector('.cd-animate');
    if ( contentDriven ) {
        let contentEls = contentDriven.querySelectorAll('.content-el');
        let polygon = contentDriven.querySelector('.deco-shape-lightblue');
        function contentAnimateOn () {
            polygon.classList.toggle('decoOn');
        }
        function contentDesktopOn () {
            polygon.classList.toggle('decoDesktopOn');
        }

        ScrollTrigger.matchMedia({
            // large
            "(min-width: 992px)": function() {
                const timelineContent = gsap.timeline({
                    scrollTrigger: {
                        onEnter: contentDesktopOn,
                        onLeaveBack: contentDesktopOn,
                        trigger: contentDriven,
                        duration: 0.5,
                        start: "0% 40%",
                        end: "100% 100%",
                        scrub: 1,
                        pin: false,
                        pinSpacing: false,
                        // markers: true
                    }
                });
                timelineContent
                .to(
                    contentEls,
                    {   
                        duration: 1,
                        y: 0,
                        stagger: 0.5,
                        opacity: 1
                    }   
                );
            },
            // small
            "(max-width: 991px)": function() {
                const timelineContent = gsap.timeline({
                    scrollTrigger: {
                        onEnter: contentAnimateOn,
                        onLeaveBack: contentAnimateOn,
                        trigger: contentDriven,
                        duration: 0.5,
                        start: "0% 60%",
                        end: "50% 60%",
                        scrub: 0.5,
                        // markers: true
                    }
                });
                timelineContent
                .to(
                    contentEls,
                    {   
                        duration: 0.5,
                        y: 0,
                        stagger: 0.2,
                        opacity: 1
                    }   
                );
            }
        });
        
    }


    // Footer
    // Wellness/Cannabis division pages use the newer site-footer.liquid markup,
    // which has no .main-footer — skip this animation there.
    const footer = document.querySelector('.main-footer');
    if (footer) {
        const footerNav = footer.querySelector('.footer-nav');
        const timelineFooter = gsap.timeline({
            scrollTrigger: {
                trigger: footer,
                scrub: 1,
                start: "100% 100%",
                end: "100% 100%",
                pin: true,
                pinSpacing: true,
                // markers: true
            }
        });
    }


    // Get styles count
    let category = document.querySelectorAll('.cat-block');
    category.forEach(cat => {
        let style = cat.querySelectorAll('.count-item');
        if ( style.length > 9 ) {
            // cat.insertAdjacentHTML('beforeend', '<h3 class="product-count d-none d-lg-block">' + style.length + '</h3>');
        } else {
            // cat.insertAdjacentHTML('beforeend', '<h3 class="product-count d-none d-lg-block">0' + style.length + '</h3>');
        }
    });
}

export default Categories;